import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {useGetInfiniteNotifications} from '@/features/notifications/queries/useGetInfiniteNotifications'
import {IconContainer} from '@/components/ui/icon-container/IconContainer'
import {Bell01Icon} from '@/components/ui/icon/Icon'
import {StyledActivitiesBox, StyledEmptyState, StyledHomeCard, StyledHomeCardContent} from './style'
import {HomeNotificationsSkeleton} from './HomeNotificationsSkeleton'
import {HomeNotificationRow} from './HomeNotificationRow'
import {useTranslation} from 'react-i18next'
import {useNotificationsPanelStore} from '@/features/notifications/store/useNotificationsPanelStore'

export const HomeNotificationsCard = () => {
    const {t} = useTranslation()
    const {notifications, isLoading} = useGetInfiniteNotifications(true, 3)
    const hasNotifications = notifications.length > 0
    // The panel itself is rendered once by NotificationButton in Header; this card only opens it.
    const openPanel = useNotificationsPanelStore(state => state.open)

    return (
        <StyledHomeCard>
            <StyledHomeCardContent>
                <Flexbox align="center" gap={4}>
                    <IconContainer size="lg" variant="primary">
                        <Bell01Icon />
                    </IconContainer>
                    <Text size="textXl" weight={500} palette="neutral" shade="600">
                        Ultime notifiche
                    </Text>
                </Flexbox>

                <StyledActivitiesBox>
                    {isLoading && !hasNotifications ? (
                        <HomeNotificationsSkeleton />
                    ) : !hasNotifications ? (
                        <StyledEmptyState>
                            <Bell01Icon size={18} />
                            <Text size="textSm" palette="neutral" shade="500">
                                {t('homepage:no_notifications_to_read')}
                            </Text>
                        </StyledEmptyState>
                    ) : (
                        <Flexbox direction="column" gap={2}>
                            {notifications.map(notification => (
                                <HomeNotificationRow key={notification.id} notification={notification} />
                            ))}
                        </Flexbox>
                    )}
                </StyledActivitiesBox>
            </StyledHomeCardContent>

            {hasNotifications && (
                <Button variant="secondary" size="sm" onClick={openPanel}>
                    Vedi tutto
                </Button>
            )}
        </StyledHomeCard>
    )
}
